module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/street-glass.abaed3e5.png";